module.exports = __webpack_public_path__ + "static/img/Nasta.a3ddbb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Nasta.png
// module id = lPCF
// module chunks = 1